import { defineMessages } from 'react-intl';

export const learnBasicsTaskMessages = defineMessages({
  evidenceQuestionFallback1: {
    defaultMessage: "What's the recommended workup for this presentation?",
    id: 'UvaahH7pmv',
    description:
      'Generic suggested Evidence question, shown on the learn-the-basics step only while the specialty-specific questions load or if that request fails',
  },
  evidenceQuestionFallback2: {
    defaultMessage: 'When should I refer or escalate this patient?',
    id: 'NO18K0gmta',
    description:
      'Generic suggested Evidence question, shown on the learn-the-basics step only while the specialty-specific questions load or if that request fails',
  },
  evidenceQuestionFallback3: {
    defaultMessage: 'What are the key risk factors to manage?',
    id: 'lYbSp1zZug',
    description:
      'Generic suggested Evidence question, shown on the learn-the-basics step only while the specialty-specific questions load or if that request fails',
  },
});
